import "core-js/actual";
import { Spin } from 'antd';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import TagManager from 'react-gtm-module';
import App from './App';
import { config } from './config';
import './i18n';
import { ThemeProvider } from "@sunday/component";

const { GTM_ID, GTM_AUTH, GTM_PREVIEW, SENTRY_DSN, SENTRY_ENVIRONMENT, SENTRY_SAMPLERATE, SENTRY_TRACESSAMPLERATE } = config;
if (GTM_ID) {
  TagManager.initialize({
    gtmId: GTM_ID,
    auth: GTM_AUTH,
    preview: GTM_PREVIEW,
  });
}

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    integrations: [new Integrations.BrowserTracing()],
    sampleRate: parseFloat(`${SENTRY_SAMPLERATE}`),
    tracesSampleRate: parseFloat(`${SENTRY_TRACESSAMPLERATE}`),
  });
}
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <ThemeProvider theme='ice-cream'>
    <React.Suspense fallback={<Spin />}>
      <Router>
        <App />
      </Router>
    </React.Suspense>
  </ThemeProvider>
);